const evaluation = {
    namespaced: true,
    state: {
        organizationId: {}, // 班级ID
        studentId: {},// 点击当前学生ID
        teachingProjectRow:'',
        averageObj: {},// 评价学生
        schooolObj: {},
        timeObj: {},
    },
    mutations: {
        getOrganizationId(state, studentOrganizationId) {
            state.organizationId = studentOrganizationId
        },

        getStudentId(state, StudentID) {
            state.studentId = StudentID
        },
        setTeachingProjectRow(state, row) {
            state.teachingProjectRow = row
        },
        // 评价学生
        changeAverageObj (state, val) {
            state.averageObj = val
        },
        changeSchoolObj (state, val) {
            state.schooolObj = val
        },
        changeTimeObj (state, val) {
            state.timeObj = val
        }
    }
  }
  export default evaluation
